export const ORG_LIMIT_SCOPE = Object.freeze({
  PLATFORM: { value: "PLATFORM" },
  ORG: { value: "ORG" },
});


export  const SCOPE_OPTIONS = [
  { label: "MASTER", value: "MASTER" },
  { label: "CUSTOMER", value: "CUSTOMER" },
  { label: "BOTH", value: "BOTH" },
]

export const ORG_LIMIT_KEY_TYPE = Object.freeze({
  PAYOUT: { value: "PAYOUT", label: "Payout", is_volume_applicable: true },
  PAYIN: { value: "PAYIN", label: "Payin", is_volume_applicable: true },
  CHECKOUT: {
    value: "CHECKOUT",
    label: "Checkout",
    is_volume_applicable: true,
  },
  VIRTUAL_ACCOUNT: {
    value: "VIRTUAL_ACCOUNT",
    label: "Virtual Account",
    is_volume_applicable: false,
  },
  CUSTOMER: {
    value: "CUSTOMER",
    label: "Customer",
    is_volume_applicable: false,
  },
  WALLET: { value: "WALLET", label: "Wallet", is_volume_applicable: false },
  BENEFICIARY: {
    value: "BENEFICIARY",
    label: "Beneficiary",
    is_volume_applicable: false,
  },
  VERIFICATION_OF_PAYEE: {
    value: "VERIFICATION_OF_PAYEE",
    label: "Verification Of Payee",
    is_volume_applicable: false,
  },
});

export const ORG_LIMIT_TYPE = Object.freeze({
  COUNT: { value: "COUNT", label: "Count" },
  VOLUME: { value: "VOLUME", label: "Volume" },
});

export const ORG_LIMIT_DURATION = Object.freeze({
  HOURLY: { value: "HOURLY", label: "Hourly" },
  DAILY: { value: "DAILY", label: "Daily" },
  WEEKLY: { value: "WEEKLY", label: "Weekly" },
  MONTHLY: { value: "MONTHLY", label: "Monthly" },
  INFINITE: { value: "INFINITE", label: "Perpetual" },
});

export const ORG_LIMIT_TABLE_CUSTOM_COLUMN = [
  {
    columnName: "Key Type",
    isVisible: true,
  },
  {
    columnName: "Type",
    isVisible: true,
  },
  {
    columnName: "Duration",
    isVisible: true,
  },
  {
    columnName: "Threshold",
    isVisible: true,
  },
  {
    columnName: "Status",
    isVisible: true,
  },
  {
    columnName: "Source",
    isVisible: true,
  },
  {
    columnName: "Scope",
    isVisible: true,
  },
];
